import { CheckCircleOutlined, CloseCircleOutlined, EditOutlined, MoreOutlined, SettingOutlined } from "@ant-design/icons";
import { Dropdown, Space, Switch, Table, Typography } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

function UserRoleTable({
  isLoading = false,
  dataSource = [],
  pagination = {},
  onEdit = () => { },
  onStatus = () => { },
  onPermissionSetting = () => { },
  onChange = () => { }
}) {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  console.log("pafge ", pagination);

  const columns = useCallback(
    () => {
      return [
        {
          title: <div className="text-table" style={{ textAlign: "center" }}>{t('employee.no')}</div>,
          dataIndex: "index",
          key: "index",
          render: (_, record, idx) => {
            return <span
              style={{
                color: "#42526D",
                backgroundColor: "#F5F6F7",
                borderRadius: "50%",
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "auto",
                padding: "8px",
                minWidth: "30px",
                height: "30px",
              }}
            >{(pagination.page - 1) * pagination.size + idx + 1}</span>
          },
          width: 90,
          align: "center"
        },
        {
          title: (
            <div className="text-table">
              {t("user_management.label.role")}
            </div>
          ),
          dataIndex: i18n.language === "en" ? "roleNameEn" : "roleName",
          key: "role",
          render: (_, record) => {
            const name = i18n.language === "en" ? record?.roleNameEn : record?.roleName;
            return name
          },
          sorter: true,
          width: 200,
        },
        {
          title: <div className="text-table">{t('common.desciption')}</div>,
          dataIndex: "description",
          key: "description",
          width: 300,
          render: (_, record) => {
            const description = record?.description || "";
            const maxLength = 160;

            return description.length > maxLength ? (
              <Typography.Paragraph ellipsis={{
                rows: 3,
                expandable: true,
                symbol: t('translation.more'),
              }}>
                {description}
              </Typography.Paragraph>
            ) : (
              <span>{description}</span>
            );
          }
        },
        {
          title: <div className="text-table" style={{ textAlign: "center" }}>{t('common.is-hr')}</div>,
          dataIndex: "roleHr",
          key: "roleHr",
          width: 120,
          render: (_, record) => {
            return record?.roleHr === 'Y' ? (
              // <CheckCircleOutlined style={{ color: 'green' }} />
              <span>{t("translation.yes")}</span>
            ) : (
              // <CloseCircleOutlined style={{ color: 'red' }} />
              <span>{t("translation.no")}</span>
            );
          },
          align: "center"
        },
        // {
        //   title: <div className="text-table" style={{ textAlign: "center" }}>{t('salary.salary')}</div>,
        //   dataIndex: "salary",
        //   key: "salary",
        //   width: 100,
        // },
        // {
        //   title: <div className="text-table" style={{ textAlign: "center" }}>{t('common.full-access')}</div>,
        //   dataIndex: "fullAccess",
        //   key: "fullAccess",
        //   width: 150,
        //   render: (_, record) => {
        //     return record?.roleCode === 'ADMINISTRATOR' ? (
        //       <CheckCircleOutlined style={{ color: 'green' }} />
        //     ) : (
        //       <CloseCircleOutlined style={{ color: 'red' }} />
        //     );
        //   },
        //   align: "center"
        // },
        {
          title: (
            <div className="text-table" style={{ textAlign: "center" }}>{t("user_management.label.status")}</div>
          ),
          dataIndex: "statusFlag",
          key: "statusFlag",
          align: "center",
          width: "120px",
          render: (text, record) => (
            <Switch
              checked={text === "ACTIVE"}
              onChange={(checked) => onStatus(checked, record)}
            />
          ),
        },
        roles.includes("UPDATE_USER_MANAGEMENT|ROLE") ? {
          title: "",
          key: "action",
          align: "center",
          width: "80px",
          render: (_, record) => (
            <Space size="middle">
              <Dropdown
                menu={{
                  items: [
                    {
                      key: "1",
                      onClick: () => onEdit(record),
                      label: `${t("action.edit")}`,
                      icon: (
                        <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                      ),
                    },
                    {
                      key: "2",
                      onClick: () => onPermissionSetting(record),
                      label: `${t("common.permission-setting")}`,
                      icon: (
                        <SettingOutlined style={{ fontSize: "18px", color: "gray" }} />
                      ),
                    },
                  ],
                }}
              >
                <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
              </Dropdown>
            </Space>
          ),
        } : {},
      ];
    }, [i18n.language, pagination]
  )


  return (
    <TableAntd
      loading={isLoading}
      columns={columns()}
      dataSource={dataSource}
      scroll={{ x: true }}
      rowKey={(record) => record.id}
      onChange={onChange}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
    />
  );
}

export default UserRoleTable;
